export const Regulars = {
	OnlyNumbers: /^[0-9]+$/,
	Email:
		/^(?!.*[-]{2})(([^>*()[\]\\.,;:\s@"]+(\.[^>*()[\]\\.,;:\s@"]+)*)|.(".+"))@((?!-)[a-zA-Z0-9\-]+(?!-)(\.[a-zA-Z0-9\-]+)*\.[a-zA-Z]{2,})$/,
	Password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,50}$/,
	PasswordWithSpecialChars:
		/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])[a-zA-Z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,50}$/,
	UUID: /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
	Alphabetic: /^[A-Za-z]+$/,
	AlphabeticAndNumericWithUnderscore: /^[A-Za-z0-9_]+$/,
	CyrillicPattern: /^[^а-яА-Я]*$/,
	AlphabeticAndNumeric: /^[A-Za-z0-9]+$/,
	AlphabeticAndNumericWithSpaces: /^[A-Za-z0-9 ]+$/,
};
